import ZonesPage from './components/ZonesPage';

const routes = [
  {
    path: '/zones',
    name: 'menu.zones',
    className: 'menu-zones',
    icon: 'zones',
    customIcon: true,
    loginRequired: true,
    component: ZonesPage,
    weight: 1,
    permission: ['zones'],
    children: [],
  },
];

export default routes;
